<!-- eslint-disable vue/no-v-html -->
<template>
	<errorContainer :error="erreur">
		<div>
			<div v-if="GetAdminValidations" class="row">
				<b-col md="12">
					<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, , { 'is-pwa': $isPwa() }]">
						{{ FormMSG(235, 'Validations') }}
					</h1>
				</b-col>
				<div class="col-12">
					<b-alert show variant="secondary">
						{{ FormMSG(1, 'Only administrators are shown in this screen. You can add more administrators in the users screen.') }}
					</b-alert>
					<b-card v-for="user in GetAdminValidations" :key="user.id" :header="userTitle(user)">
						<!-- <div class="row"> -->
						<div class="row">
							<div v-for="(validation, i) in user.validations" :key="i" class="col-12 col-sm-6">
								<b-card class="card-accent-primary">
									<div slot="header">
										{{ validation.departmentName }}
										<div class="card-header-actions">
											<a href="#" @click.prevent="deleteValidation(validation.id)"><i class="icon-close" /></a>
										</div>
									</div>
									<b-form-group :label="FormMSG(40, 'Timesheet')" label-for="ts" :label-cols="5">
										<b-form-select
											id="ts"
											v-model="validation.validationLevelTs"
											:plain="true"
											:options="optionsForValidationLevel"
											@change="
												addOrUpdateValidation(
													isUpdate,
													validation.id,
													parseInt(user.id),
													validation.department,
													validation.validationLevelTs,
													validation.validationLevelPo,
													validation.validationLevelExp,
													validation.validationLevelInvoice
												)
											"
										/>
									</b-form-group>
									<b-form-group :label="FormMSG(41, 'Purchase Order')" label-for="po" :label-cols="5">
										<b-form-select
											id="po"
											v-model="validation.validationLevelPo"
											:plain="true"
											:options="optionsForValidationLevel"
											value="test"
											@change="
												addOrUpdateValidation(
													isUpdate,
													validation.id,
													parseInt(user.id),
													validation.department,
													validation.validationLevelTs,
													validation.validationLevelPo,
													validation.validationLevelExp,
													validation.validationLevelInvoice
												)
											"
										/>
									</b-form-group>
									<b-form-group :label="FormMSG(42, 'Expense')" label-for="exp" :label-cols="5">
										<b-form-select
											id="exp"
											v-model="validation.validationLevelExp"
											:plain="true"
											:options="optionsForValidationLevel"
											@change="
												addOrUpdateValidation(
													isUpdate,
													validation.id,
													parseInt(user.id),
													validation.department,
													validation.validationLevelTs,
													validation.validationLevelPo,
													validation.validationLevelExp,
													validation.validationLevelInvoice
												)
											"
										/>
									</b-form-group>
									<b-form-group :label="FormMSG(43, 'Invoices')" label-for="invoices" :label-cols="5">
										<b-form-select
											id="exp"
											v-model="validation.validationLevelInvoice"
											:plain="true"
											:options="optionsForValidationLevel"
											@change="
												addOrUpdateValidation(
													isUpdate,
													validation.id,
													parseInt(user.id),
													validation.department,
													validation.validationLevelTs,
													validation.validationLevelPo,
													validation.validationLevelExp,
													validation.validationLevelInvoice
												)
											"
										/>
									</b-form-group>
								</b-card>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<b-button
									variant="outline-success"
									block
									@click="addDepartmentPrompt(user.id, user.name + ' ' + user.firstName)"
									v-html="FormMSG(20, 'Add Department')"
								/>
							</div>
						</div>
					</b-card>
				</div>
			</div>
			<b-modal
				v-model="showModal"
				header-class="header-class-modal-doc-package"
				class="modal-success"
				hide-footer
				:title="'Add validation to ' + currentUserName + ' for'"
			>
				<div v-for="(department, i) in availableDepartments" :key="i">
					<a href="#" @click.prevent="addDepartment(department)">{{ department.message }}</a>
				</div>
			</b-modal>
		</div>
	</errorContainer>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import {
	getAdminValidations as Q_getAdminValidations,
	getDepartmentsForValidation as Q_getDepartmentsForValidation,
	AddUpdValidation as M_AddUpdValidation,
	DeleteValidation as M_DeleteValidation
} from '@/cruds/validations.crud';
import { store } from '@/store';
import { DEPARTEMENT_VALIDATION } from '@/utils/utils';
import { getDepartments } from '@/cruds/department.crud';
import { mapGetters, mapActions } from 'vuex';

let idGlobal = 1000;

export default {
	//name: "two-lists",
	name: 'Validations',
	mixins: [languageMessages],
	display: 'Two Lists',
	order: 1,
	data() {
		const { isAdd, isUpdate } = DEPARTEMENT_VALIDATION;
		return {
			erreur: {},
			showModal: false,
			currentUserID: 0,
			currentUserName: '',
			GetAdminValidations: [],
			GetDepartmentsForValidation: [],
			isAdd,
			isUpdate
		};
	},
	computed: {
		...mapGetters({
			getMyProfile: 'profile/getMyProfile'
		}),
		optionsForValidationLevel() {
			return this.FormMenu(1013);
		},
		availableDepartments: function () {
			var departmentNames = [];
			var ret = [];
			//console.log("this.GetDepartmentsForValidation:",this.GetDepartmentsForValidation);
			if (Object.keys(this.GetAdminValidations).length === 0 || Object.keys(this.GetDepartmentsForValidation).length === 0) {
				return null;
			}

			for (var i = 0; i < this.GetAdminValidations.length; i++) {
				if (this.GetAdminValidations[i].id == this.currentUserID) {
					for (var l = 0; l < this.GetAdminValidations[i].validations.length; l++) {
						departmentNames.push(this.GetAdminValidations[i].validations[l].departmentName);
					}
					break;
				}
			}

			for (var j = 0; j < this.GetDepartmentsForValidation.length; j++) {
				var isAlreadyUsed = false;
				for (var k = 0; k < departmentNames.length; k++) {
					if (this.GetDepartmentsForValidation[j].message == departmentNames[k]) {
						isAlreadyUsed = true;
						break;
					}
				}
				if (!isAlreadyUsed) {
					ret.push(this.GetDepartmentsForValidation[j]);
				}
			}

			return ret;
		}
	},
	async created() {
		await this.initialize();
	},
	methods: {
		...mapActions({
			getNotifications: 'header/getNotifications'
		}),
		async initialize() {
			let result_getAdminValidations = await Q_getAdminValidations();
			let result_getDepartmentsForValidation = await getDepartments();
			result_getAdminValidations !== undefined && (this.GetAdminValidations = result_getAdminValidations);
			result_getDepartmentsForValidation !== undefined && (this.GetDepartmentsForValidation = result_getDepartmentsForValidation);
		},
		userTitle: function (user) {
			if (user.name.length > 0 || user.firstName.length > 0) {
				return user.name + ' ' + user.firstName;
			} else {
				return user.email;
			}
		},
		async deleteValidationGql(UserId, DepartmentNumber) {
			let result = await M_DeleteValidation({ UserId, DepartmentNumber, Type: 0 });
			if (this.getMyProfile && +this.getMyProfile.id === +UserId) await this.getNotifications(); // refresh header Notification bell.
			return result;
		},
		addOrUpdateValidation: async function (action, ValidationId, UserId, DepartmentNumber, LevelTs, LevelPo, LevelExp, LevelInvoice, Replace) {
			if (DepartmentNumber === 0) {
				DepartmentNumber = -1;
			}
			await M_AddUpdValidation({
				ValidationId: action === this.isAdd ? 0 : ValidationId,
				UserId: UserId,
				ProjectId: +store.projectID(),
				UpdValidation: {
					type: 0,
					department: DepartmentNumber,
					validationLevelTs: LevelTs,
					validationLevelPo: LevelPo,
					validationLevelExp: LevelExp,
					validationLevelInvoice: LevelInvoice
				},
				Replace
			});
			if (this.getMyProfile && +this.getMyProfile.id === +UserId) await this.getNotifications(); // refresh header Notification bell.
		},
		addDepartmentPrompt: function (userID, userName) {
			this.currentUserID = parseInt(userID);
			this.currentUserName = userName;
			this.showModal = true;
		},
		async addDepartment(department) {
			var validation = JSON.parse(JSON.stringify(department));
			validation.departmentName = validation.message;
			validation.department = validation.value;
			validation.validationLevelTs = 0;
			validation.validationLevelPo = 0;
			validation.validationLevelExp = 0;
			validation.validationLevelInvoice = 0;
			// Add validation to user
			if (validation.value === 0) {
				validation.department = -1;
			}
			await M_AddUpdValidation({
				ValidationId: 0,
				UserId: this.currentUserID,
				ProjectId: +store.projectID(),
				UpdValidation: {
					type: 0,
					department: validation.value,
					validationLevelTs: validation.validationLevelTs,
					validationLevelPo: validation.validationLevelPo,
					validationLevelExp: validation.validationLevelExp,
					validationLevelInvoice: validation.validationLevelInvoice
				}
			}).then((res) => {
				// console.log(res);
				res.departmentName = validation.message;
				for (var i = 0; i < this.GetAdminValidations.length; i++) {
					if (this.GetAdminValidations[i].id == this.currentUserID) {
						this.GetAdminValidations[i].validations.push(res);
						break;
					}
				}
			});
			if (this.getMyProfile && +this.getMyProfile.id === +this.currentUserID) await this.getNotifications(); // refresh header Notification bell.
			// liste

			// // graphql
			// this.addOrUpdateValidation(
			// 	this.isAdd,
			// 	0,
			// 	this.currentUserID,
			// 	validation.value,
			// 	validation.validationLevelTs,
			// 	validation.validationLevelPo,
			// 	validation.validationLevelExp
			// );

			// hide modal
			this.showModal = false;
			this.currentUserID = 0;
			this.currentUserName = '';
		},
		deleteValidation: function (id) {
			//console.log("delete validation:", id)
			for (var i = 0; i < this.GetAdminValidations.length; i++) {
				for (var j = 0; j < this.GetAdminValidations[i].validations.length; j++) {
					if (this.GetAdminValidations[i].validations[j].id == id) {
						this.deleteValidationGql(parseInt(this.GetAdminValidations[i].id), this.GetAdminValidations[i].validations[j].department);
						this.GetAdminValidations[i].validations.splice(j, 1); // remove element
						return;
					}
				}
			}
		}
	}
};
</script>

<style>
.movable {
	cursor: move;
}
.ghost {
	background-color: grey;
}
.draggable {
	margin-left: 10px;
}
.drophere {
	padding: 10px;
	/* background-color: rgba(249, 249, 249, 1); */
	/* border: 1px dashed rgb(206, 206, 206); */
	-webkit-border-radius: 5px;
	border-radius: 5px;
}
</style>
